import { RawWappMessage } from '@weblite/ts-action/message'
import { sendNewMessage, sendWappMessage } from '$logic/message'
import { instantiateWapp } from '$logic/wapps/service'
import { getOpenedRoomId } from '$logic/opened-room'
import {
  showMessagesSentSuccessfullySnackbar,
  showNoPermissionToSendWappErrorSnackbar,
} from '$comp/snackbars'
import { getWis } from '$logic/wises'
import { openForwardMenuModal } from '$comp/modals/forward-menu'
import { getRoom, getRoomPermissions } from '$logic/room'

export async function shareInlineWapp(
  inlineAttachment: RawWappMessage['attachment'],
  shouldShowForwardList: boolean,
  contentUri?: string,
) {
  if (!inlineAttachment) return
  const openedRoomId = getOpenedRoomId()
  const { roomId, caption } =
    !shouldShowForwardList && openedRoomId
      ? { roomId: openedRoomId, caption: '' }
      : await new Promise<{ roomId: string; caption: string }>(res => {
          openForwardMenuModal({
            onConfirm: async ([selectedRoom], text) => {
              res({ roomId: selectedRoom, caption: text || '' })
            },
          })
        })

  const room = await getRoom(roomId)
  if (!room) return
  const { wappId, wisId, input } = inlineAttachment

  const roomPermission = await getRoomPermissions(roomId)

  const hasPermissionToSendWapp = roomPermission.sendWapp

  if (!hasPermissionToSendWapp) {
    showNoPermissionToSendWappErrorSnackbar()
    return
  }
  if (caption)
    await sendNewMessage(undefined, caption, undefined, roomId, room?.type)

  if (wisId) {
    // wis is already created; so not needed to do anything
    const wisCustomize = (await getWis(wisId))?.customize
    await sendWappMessage(
      roomId,
      {
        ...inlineAttachment,
        wisId,
        input: wisCustomize,
      },
      room?.type,
    )
    showMessagesSentSuccessfullySnackbar()

    return
  }

  // Instantiate wapp
  const messageInput =
    input || contentUri ? { ...input, contentUri } : undefined
  const messageWisId = messageInput
    ? await instantiateWapp(wappId, messageInput)
    : undefined

  await sendWappMessage(
    roomId,
    {
      ...inlineAttachment,
      wisId: messageWisId,
      input: messageInput,
    },
    room?.type,
  )
  showMessagesSentSuccessfullySnackbar()
}
